<template>
  <!-- Profile Modal -->
  <v-dialog v-model="modalDialog" max-width="725px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Profile Information</h5>
        <button type="button" class="close" @click="method(employee)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="putProfileInfo">
          <div class="row">
            <div class="col-md-12">
              <div
                class="alert alert-danger alert-dismissible fade show"
                role="alert"
                v-if="error"
              >
                <strong>Error!</strong> {{ error }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
            <div class="col-md-12">
              <div
                class="alert alert-success alert-dismissible fade show"
                role="alert"
                v-if="message"
              >
                <strong>Success!</strong> {{ message }}
                <button
                  type="button"
                  class="close"
                  data-dismiss="alert"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="profile-img-wrap edit-img">
                <img
                  class="inline-block"
                  alt="user"
                  :src="media + passportPhoto"
                  v-if="passportPhoto"
                />
                <img
                  class="inline-block"
                  alt="user"
                  src="~@/assets/profiles/avatar-02.jpg"
                  v-if="!passportPhoto"
                />
                <div class="fileupload btn">
                  <span class="btn-text">edit</span>
                  <input
                    class="upload"
                    type="file"
                    ref="file"
                    accept="image/*"
                    @change="onFilePicked"
                  />
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>First Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="$v.firstName.$model"
                      :class="{
                        'is-invalid': submitted && $v.firstName.$error
                      }"
                    />
                  </div>
                  <div
                    v-if="submitted && !$v.firstName.required"
                    class="invalid-feedback"
                  >
                    First Name is required
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Last Name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model.trim="$v.lastName.$model"
                      :class="{ 'is-invalid': submitted && $v.lastName.$error }"
                    />
                  </div>
                  <div
                    v-if="submitted && !$v.lastName.required"
                    class="invalid-feedback"
                  >
                    Last Name is required
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Birth Date</label>
                    <div class="cal-icon">
                      <datepicker
                        v-model.trim="$v.birthday.$model"
                        bootstrap-styling
                        class="datetimepicker"
                        type="date"
                        :class="{
                          'is-invalid': submitted && $v.birthday.$error
                        }"
                      />
                    </div>
                    <div
                      v-if="submitted && !$v.birthday.required"
                      class="invalid-feedback"
                    >
                      Birth Date is required
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>Gender</label>
                    <select
                      class="select form-control"
                      v-model.trim="$v.gender.$model"
                      :class="{ 'is-invalid': submitted && $v.gender.$error }"
                    >
                      <option value="male">Male</option>
                      <option value="female">Female</option>
                    </select>
                  </div>
                  <div
                    v-if="submitted && !$v.gender.required"
                    class="invalid-feedback"
                  >
                    Gender is required
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label>Address</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="$v.address.$model"
                  :class="{ 'is-invalid': submitted && $v.address.$error }"
                />
              </div>
              <div
                v-if="submitted && !$v.address.required"
                class="invalid-feedback"
              >
                Address is required
              </div>
            </div>

            <div class="col-md-6">
              <div class="form-group">
                <label>Phone Number</label>
                <input
                  type="text"
                  class="form-control"
                  v-model.trim="$v.phone.$model"
                  :class="{ 'is-invalid': submitted && $v.phone.$error }"
                />
              </div>
              <div
                v-if="submitted && !$v.phone.required"
                class="invalid-feedback"
              >
                Phone is required
              </div>
            </div>
          </div>
          <div class="submit-section">
            <button class="btn btn-primary submit-btn">Submit</button>
          </div>
        </form>
      </div>
    </div>
  </v-dialog>
  <!-- /Profile Modal -->
</template>

<script>
import { required, sameAs } from "vuelidate/lib/validators";
import Datepicker from "vuejs-datepicker";
import { workerService } from "@/services/workerService";
import { authenticationService } from "@/services/authenticationService";
export default {
  components: {
    Datepicker
  },
  props: {
    model: {},
    dialog: Boolean,
    method: { type: Function }
  },
  data() {
    return {
      company: authenticationService.currentOfficeValue,
      passportPhoto: this.model.passportPhoto,
      media: "data:image/jpeg;base64,",
      modalDialog: this.dialog,
      employee: null,
      employees: [],
      firstName: this.model.firstName,
      lastName: this.model.lastName,
      birthday: this.model.birthday,
      gender: this.model.gender,
      address: this.model.address,
      phone: this.model.phone,
      message: "",
      error: "",
      file: null,
      submitted: false
    };
  },

  validations: {
    firstName: { required },
    lastName: { required },
    phone: { required },
    birthday: { required },
    address: { required },
    gender: { required }
  },
  mounted() {
    this.GetEmployees();
    this.$emit("update:employee", this.employee);
    this.$emit("update:profileDialog", this.dialog);
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
  },
  methods: {
    onFilePicked(event) {
      const files = event.target.files;
      let filename = files[0].name;
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.file = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.file = files[0];
      workerService.changeCasualWorkerPhoto(files[0], this.model.id).then(
        m => {
          this.passportPhoto = m.passportPhoto;
        },
        e => (this.error = e.title)
      );
    },
    putProfileInfo() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.model.firstName = this.firstName;
      (this.model.lastName = this.lastName),
        (this.model.phone = this.phone),
        (this.model.birthday = this.birthday),
        (this.model.gender = this.gender),
        (this.model.address = this.address),
        workerService
          .updateCasualWorkerProfileInfo(this.model.id, this.model)
          .then(d => {
            this.message = "Profile Info update successfully!";
            workerService.getEmployeeDetail(this.model.id).then(
              model => {
                this.employee = model;

                if (!this.employee.casualWorkerStatutory) {
                  this.employee.casualWorkerStatutory = {
                    id: 0,
                    salaryBasis: "",
                    salaryAmount: 0.0
                  };
                }
                if (!this.employee.casualWorkerTax) {
                  this.employee.casualWorkerTax = {
                    id: 0,
                    tin: "",
                    taxCode: "",
                    taxOffice: "",
                    tax: {}
                  };
                } else {
                  this.employee.casualWorkerTax.tax = {
                    taxOffice: this.employee.casualWorkerTax.taxCode,
                    description: this.employee.casualWorkerTax.taxOffice
                  };
                }
                this.method(this.employee);
              },
              error => {
                this.error = error;
              }
            );
          });
    },
    GetEmployees() {
      workerService.getEmployeeDetail(this.company.id).then(
        model => {
          this.employees = model;
        },
        error => {
          this.error = error;
        }
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/casualworker/CProfileModal.vue